import { selectHelplyAccountId } from 'ducks/accounts/selectors/selectHelplyAccountId'

// Whether this Groove account has the Helply Copilot addon enabled — gates the
// copilot panel (any user in an entitled account may use it).
//
// TODO(groove-backend): back this with the real addon/entitlement.
export const selectHasHelplyCopilotAddon = state => {
  if (selectHelplyAccountId(state)) return true
  return false
}
